import React, {useEffect, useState} from 'react'
import { FaArrowRight, FaSpinner, FaPlus, FaMinus, FaTimes, FaInfoCircle, FaSync, FaSearch } from 'react-icons/fa';
import { IoIosCloseCircle } from "react-icons/io";
import { Link, useNavigate } from 'react-router-dom';

import { useSettings } from '../context/SettingsContext'

import { Nav } from './partials/Nav';
import Search from './Search';
import ParkingList from './partials/ParkingList';
import ParkingModal from './partials/ParkingModal';
import Loading from './partials/Loading';
import StatusKey from './partials/StatusKey';

import {API_URL} from './Constants';

const Home = () => {
  const settings = useSettings();

  const navigate = useNavigate();
  
  const [showAdd, setShowAdd] = useState(false)
  const [lots, setLots] = useState()
  const [parkingData, setParkingData] = useState([])
  const [gettingData, setGettingData] = useState(true)
  const [lotData, setLotData] = useState()
  const [showClosed, setShowClosed] = useState(false)
  const [timePeriod, setTimePeriod] = useState('all')
  const [selectedParkingId, setSelectedParkingId] = useState(null)
  const [showStatusKey, setShowStatusKey] = useState(false)
  const [showParkingModal, setShowParkingModal] = useState(false)
  const [showQuickSearch, setShowQuickSearch] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')
  const [showCloseLotModal, setShowCloseLotModal] = useState(false)
  const [closingLot, setClosingLot] = useState(false)

  const handleParkingSelect = (id) => {
    setSelectedParkingId(id);
    setShowParkingModal(true);
  }

  const handleCloseModal = () => {
    setShowParkingModal(false);
    setSelectedParkingId(null);
  }

  useEffect(() => {
    document.title = 'Home | ValParx'
    if (settings && settings.userToken) {
      getData(settings.userToken)
    }

    console.log(settings.selectedLot);

    if (settings.selectedLot) {
      getLotData()
      
      // Set up interval to fetch lot data every 1 minute
      let intervalId = setInterval(getLotData, 60 * 1000);

      // Function to handle user activity
      const handleActivity = () => {
        // Clear existing interval
        clearInterval(intervalId);
        // Start a new interval
        intervalId = setInterval(getLotData, 60 * 1000);
      };

      // Add event listeners for various user activities
      window.addEventListener('keypress', handleActivity);
      window.addEventListener('click', handleActivity);
      window.addEventListener('touchstart', handleActivity);

      // Cleanup function to remove event listeners and clear interval
      return () => {
        clearInterval(intervalId);
        window.removeEventListener('keypress', handleActivity);
        window.removeEventListener('click', handleActivity);
        window.removeEventListener('touchstart', handleActivity);
      };
    }
  }, [settings, settings.selectedLot, showClosed, timePeriod]);

  const getLotData = () => {
    if (!settings.userToken || !settings.selectedLot) return;
    
    setGettingData(true)
    var myHeaders = new Headers();
    myHeaders.append("vp-session-token", settings.userToken);

    var formdata = new FormData();
    formdata.append("id", settings.selectedLot);
    
    if (showClosed) {
      formdata.append("closed", "1");
    }
    formdata.append("time_period", timePeriod);

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };

    fetch(API_URL + "getopen", requestOptions)
      .then(response => response.json())
      .then(result => {
        setGettingData(false)
        if (result.code == 200) {
          setParkingData(result.parking)
          setLotData({
            in: result.in,
            out: result.out,
            now: result.now
          })
        } else {
          setParkingData([])
          setLotData({
            in: 0,
            out: 0,
            now: 0
          })
        }
      })
      .catch(error => {
        console.log('error', error)
        setGettingData(false)
        setParkingData([])
        setLotData({
          in: 0,
          out: 0,
          now: 0
        })
      });
  }

  const refreshData = () => {
    getLotData()
  }

  const editTransaction = (transactionId) => {
    navigate('/transaction/edit/'+transactionId);
  }

  const reparkCar = (transactionId) => {
    const isConfirmed = window.confirm('Are you sure you want to repark this vehicle? This action will close the ticket and reopen another.');

    if (isConfirmed) {
      var myHeaders = new Headers();
      myHeaders.append("vp-session-token", settings.userToken);

      var formdata = new FormData();
      formdata.append('transaction_id', transactionId);

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(API_URL + "repark", requestOptions)
        .then(response => response.json())
        .then(result => {
          //console.log(result)
          if (result.code == 200) {
            refreshData();
          } else {
            alert(result.message)
          }
        })
        .catch(error => {
          console.log('error', error)
        });
    }
  }

  const toggleClosed = (x) => {
    setShowClosed(x === 1)
  }

  const getData = (token) => {
    //console.log('getting data')
    var myHeaders = new Headers();
    myHeaders.append("vp-session-token", token);

    var formdata = new FormData();

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };

    fetch(API_URL + "getlots", requestOptions)
      .then(response => response.json())
      .then(result => {
        //console.log(result)
        if (result.code == 200) {
          setLots(result.lots)
        } else {
          alert(result.message)
        }
      })
      .catch(error => {
        console.log('error', error)
      });
  }

  // Filter parking data based on search term
  const filteredParkingData = (parkingData || []).filter(item => {
    if (!searchTerm) return true;
    
    const searchLower = searchTerm.toLowerCase();
    const keyTag = (item.key_tag || '').toLowerCase();
    const vehiclePlate = (item.vehicle_plate || '').toLowerCase();
    
    return keyTag.includes(searchLower) || vehiclePlate.includes(searchLower);
  });

  const closeLot = () => {
    if (!settings.userToken || !settings.selectedLot) return;
    setShowCloseLotModal(true);
  }

  const confirmCloseLot = () => {
    if (!settings.userToken || !settings.selectedLot) return;
    
    setClosingLot(true);
    
    var myHeaders = new Headers();
    myHeaders.append("vp-session-token", settings.userToken);

    var formdata = new FormData();
    formdata.append('lot_id', settings.selectedLot);

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };

    fetch(API_URL + "closelot", requestOptions)
      .then(response => response.json())
      .then(result => {
        setClosingLot(false);
        setShowCloseLotModal(false);
        // Refresh lot data regardless of success or error
        refreshData();
      })
      .catch(error => {
        console.log('error', error);
        setClosingLot(false);
        setShowCloseLotModal(false);
        // Refresh lot data even on error
        refreshData();
      });
  }

  return (
    <>
      <div className='min-h-screen'>
        <Nav lotData={settings.selectedLot ? lotData : null} />
        
        <div className={settings.selectedLot ? 'pt-28' : 'pt-12' + ' lg:px-10 px-5 pb-24'}>
          {settings.selectedLot ? (
            <div className="text-center">
              <div className='flex justify-center items-center mb-2 gap-5'>
                <button 
                  onClick={() => setShowAdd(!showAdd)}
                  className="py-2 px-5 bg-darkgrey rounded-3xl text-white text-lg font-bold uppercase hover:bg-accent transition-colors flex items-center gap-2"
                >
                  {showAdd ? ( <><FaMinus className="text-lg" /> <span>Hide Form</span></> ) : ( <><FaPlus className="text-lg" /> <span>Add Transaction</span></> )}
                </button>
              </div>
              
              {showAdd && (
                <div className='mb-12 bg-accent pb-14'>
                  <Search />
                  <p className='mb-10 text-white'>- or -</p>
                  <Link className="py-4 px-6 bg-darkgrey rounded-3xl text-white text-xl font-bold uppercase hover:bg-accent transition-colors" to={"/add/"}>Start Blank Transaction</Link>
                </div>
              )}

              <div className='flex justify-center items-center gap-3 mb-2 mt-4'>
                <button 
                  onClick={() => setShowStatusKey(true)}
                  className="py-1 px-2 bg-darkgrey rounded-3xl text-white text-sm font-bold uppercase hover:bg-accent transition-colors flex items-center gap-2"
                >
                  <FaInfoCircle className="text-lg" /> <span>View Status Key</span>
                </button>
                <button 
                  onClick={() => settings.updateSelectedLot(null, null)}
                  className="py-1 px-2 bg-darkgrey rounded-3xl text-white text-sm font-bold uppercase hover:bg-accent transition-colors"
                >
                  Change Lot Selection
                </button>
              </div>
              <div className='flex justify-center items-center gap-3 mb-6'>
                <button 
                  onClick={() => setShowQuickSearch(!showQuickSearch)}
                  className="py-1 px-2 bg-darkgrey rounded-3xl text-white text-sm font-bold uppercase hover:bg-accent transition-colors flex items-center gap-2"
                >
                  <FaSearch className="text-lg" /> <span>Quick Search</span>
                </button>
                <button 
                  onClick={refreshData}
                  className="py-1 px-2 bg-darkgrey rounded-3xl text-white text-sm font-bold uppercase hover:bg-accent transition-colors flex items-center gap-2"
                >
                  <FaSync className="text-lg" /> <span>Refresh Data</span>
                </button>
                <button 
                  onClick={closeLot}
                  className="py-1 px-2 bg-darkgrey rounded-3xl text-white text-sm font-bold uppercase hover:bg-accent transition-colors flex items-center gap-2"
                >
                  <IoIosCloseCircle className="text-lg" /> <span>Close Lot</span>
                </button>
              </div>

              <StatusKey isOpen={showStatusKey} onClose={() => setShowStatusKey(false)} />

              {showQuickSearch && (
                <div className='mb-6 bg-gray-100 p-4 rounded-lg max-w-md mx-auto'>
                  <div className='flex items-center gap-2'>
                    <FaSearch className="text-gray-600" />
                    <input
                      type="text"
                      placeholder="Search by key tag or plate..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      className="flex-1 py-2 px-3 border border-gray-300 rounded-md focus:outline-none focus:ring-accent focus:border-accent"
                    />
                    {searchTerm && (
                      <button
                        onClick={() => setSearchTerm('')}
                        className="p-2 text-gray-600 hover:text-accent transition-colors"
                      >
                        <FaTimes />
                      </button>
                    )}
                  </div>
                </div>
              )}

              <ParkingModal 
                isOpen={showParkingModal}
                onClose={handleCloseModal}
                parkingData={parkingData || []}
                selectedParkingId={selectedParkingId}
                onEdit={editTransaction}
                onRepark={reparkCar}
              />

              {/* Close Lot Confirmation Modal */}
              {showCloseLotModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                  <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6">
                    <div className="mb-4">
                      <h2 className="text-2xl font-bold text-gray-900 mb-2">Close Lot</h2>
                      <p className="text-gray-600">
                        Are you sure you want to close all open transactions for this lot? This action is irreversible.
                      </p>
                    </div>
                    <div className="flex gap-3 justify-end">
                      <button
                        onClick={() => setShowCloseLotModal(false)}
                        disabled={closingLot}
                        className="py-2 px-6 bg-gray-200 hover:bg-gray-300 text-gray-800 font-semibold rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed w-52"
                      >
                        No
                      </button>
                      <button
                        onClick={confirmCloseLot}
                        disabled={closingLot}
                        className="py-2 px-6 bg-red-600 hover:bg-red-700 text-white font-semibold rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
                      >
                        {closingLot ? (
                          <>
                            <FaSpinner className="animate-spin" />
                            <span>Closing...</span>
                          </>
                        ) : (
                          <span>Yes, Close Lot</span>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              )}

              <div className="py-3 mx-auto mb-10">
                {gettingData ? (
                  <Loading />
                ) : (
                  filteredParkingData && filteredParkingData.length > 0 ? (
                    <ParkingList data={filteredParkingData} onSelect={handleParkingSelect} />
                  ) : (
                    <p className='text-center text-xl py-20'>
                      {searchTerm ? 'No vehicles found matching your search.' : 'No vehicles found for the selected time period.'}
                    </p>
                  )
                )}
              </div>

              <p className="md:text-3xl text-xl font-bold mb-5">Selected Lot: <span className="text-accent">{settings.selectedLotTitle}</span></p>

              <div className="py-3 max-w-lg mx-auto">
                <div className="flex items-center justify-between mb-4">
                  <label htmlFor="time-period" className="text-xs font-medium text-gray-700 mr-2">Time Period:</label>
                  <select
                    id="time-period"
                    value={timePeriod}
                    onChange={(e) => setTimePeriod(e.target.value)}
                    className="text-xs py-1 px-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-accent focus:border-accent"
                  >
                    <option value="all">All time</option>
                    <option value="90days">Last 90 days</option>
                    <option value="month">Last month</option>
                    <option value="week">Last week</option>
                    <option value="today">Today</option>
                  </select>
                </div>
                
                <div className="bg-gray-200 rounded-lg mb-5 p-1">
                  <div className="relative flex items-center">
                    <div id="segment-selection" className={`absolute left-0 inset-y-0 w-1/2 flex bg-white transition-all ease-in-out duration-200 transform rounded-md shadow translate-x-0 ${showClosed ? 'translate-x-full' : 'translate-x-0'}`}></div>
                    <a className='relative flex-1 flex text-sm font-semibold capitalize items-center justify-center cursor-pointer m-px p-px' onClick={() => toggleClosed(0)}>Open</a>
                    <a className='relative flex-1 flex text-sm font-semibold capitalize items-center justify-center cursor-pointer m-px p-px' onClick={() => toggleClosed(1)}>Closed</a>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            lots ? (
              lots.length > 0 ? (
                <div>
                  <h2 className="text-xl font-medium text-center mb-6">Select a Lot:</h2>
                  <ul id='sites' className={`w-full max-w-2xl mx-auto`}>
                    {lots.map((lot, index) => (
                      <li key={index} className="mb-2">
                        <button 
                          onClick={() => settings.updateSelectedLot(lot.id, lot.title)} 
                          className="w-full uppercase py-1 font-bold flex justify-between items-center bg-gray-100 rounded-lg p-2"
                        >
                          <span className='overflow-x-clip text-gray-900'>{lot.title}</span>
                          <FaArrowRight className='mr-2 text-sm text-accent' />
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              ) : (
                <p className='text-center font-medium'>No active lots found. <br></br>You can start adding some with the button above.</p>
              )
            ) : (
              <p className='text-blueGray-500 items-center flex text-center justify-center'>
                <span>Loading Lots...</span>
                <FaSpinner className='text-sm ml-2 fa-spin' />
              </p>
            )
          )}
        </div>
      </div>
      {/* settings.selectedLot && (
        <div className='flex bg-primary w-full p-2 lg:p-4 fixed bottom-0'>
          <button 
            onClick={() => setShowAdd(!showAdd)}
            className='flex items-center justify-center w-full py-3 px-4 bg-darkgrey rounded-3xl max-w-[600px] mx-auto'
          >
            <div className='text-center text-white text-xl font-bold uppercase'>Add</div>
          </button>
        </div>
      ) */}
    </>
  )
}

export default Home
